export default {
    errors: {
        no_orders: "Order not found",
        db_query_failed: "Database Error",
        db_fetch_failed: "Database Error",
        permission_denied: "Access Denied",
        invalid_param: "Invalid Parameter",
        internal: "Server Error",
        payment_method_not_found: "Payment method not found",
        inventory_not_found: "Product not exist in Inventory",
		orders:{
			not_found:"Order not found",
			map_product:"Product not sync to inventory",
			invalid_date_range: "Daterange can't over 31 day",
		},
        user: {
            duplicate: "Duplicate User information",
            duplicate_username: "Duplicate Username information",
            duplicate_email: "Duplicate email information",
            blcok_delete_by_self: "Can't delete data by yourself.",
            fail: "Error update user information",
            email_wrong_format: "Wrong email format"
        },
        auth: {
            login_fail: "Login Fail",
            block: "User has been blocked",
            login_success: "Login Success",
            logout_success: "Log out Success",
            unauthoriezed: "No permission",
            reset_invalid_token: "token invalid",
            reset_token_expired: "token reset_token_expired",
            forgot_password_fail: "forgot password failed",
            reset_password_fail: "reset password failed",
            username_wrong_format: "Wrong username format",
            password_wrong_format: "Wrong password format",
            token: "Invalid Token",
            password: "Invalid password",
            password_confirm: "Invalid confirm password"
        },
        profile: {
            change_profile_failed: "Change profile failed",
            change_password_failed: "Change password failed",
            password_confirm_not_match: "Error confirm password",
            password_confirm_wrong_format: "Wrogn password format.",
            password_old_wrong: "Wrong old password"
        },
        wms: {
            inventory_create_fails: "Create inventory failed",
            inventory: {
                balance_not_enough: "Product not enought"
            }
        },
        wh: {},
        packing: {
            invalid_order_status: "Invalid Order Status",
            goods_is_added: "Goods already added"
        }
    },
    bc_user: "User",
    bc_change_profile: "User information",
    bc_change_password: "Change password",
    bc_admin: "Admin",
    bc_platform_connect: "Platform Connect",

    profile: {
        profile: "Profile",
        info: "UserInfomation",
        name: "Name",
        lname: "Surname",
        phone: "Phone",
        email: "E-Mail",
        change_password: "Change Password",
        password_old: "Old Password",
        password_new: "New Password",
        password_confirm: "Confirm Password",
        change_profile_success: "Change profile successed",
        change_password_success: "Change password successed"
    },
    menu: {
        user: "User",
        admin: "Administrator",
        admin_product: "Product and promotion",
        admin_platform_connect: "Platform Connect",
        sale_channel: "Sale Channel",
        product: "Product",
        team: "Team",
        order_status: "Status"
    },
    auth: {
        unverify: "User not verfy",
        block: "User has been blocked",
        signin: "Signin",
        signout: "Signout",
        username: "Username",
        email: "E-Mail",
        password: "Password",
        forgetpassword: "Forgot Password",
        resetpassword: "Reset Password",
        confirm_reset_password: "Confirm reset password ",
        forgot_password_success: "Forgot password successfully",
        reset_password_success: "Reset password successfully"
    },

    user: {
		create: "Create User",
		name: "Name",
		username: "Username",
		type: "Type",
		phone: "Phone",
		role: "Role",
		create_success: "Create User successed",
		create_fail: "Create User failed"
    },
    name: "Name",
    description: "Description",
    location_x: "Location (X)",
    location_y: "Location (Y)",
    group_name: "Group name",
    email: "E-Mail",
    email_optional: "E-Mail (Optional)",
    created: "Create Date",
    payment_at: "Payment Date",
    search: "Search",
    save: "Save",
    back: "Back",
    new: "New",
    status: "Status",
    download: "Download",
    downloadall: "Download All",
    product_search: "Product Search",
    welcome: "Welcome",
    myprofile: "Profile",
    changepassword: "Change Password",
	page_notfound: "Sorry Page not found.",
	page_notfound_desc: "Plase check URL again.",
	actions: "Action",
    data: "Data",
    to: "To",
    of: "From",
    row_select: "Selected",
    yes: "Yes",
    no: "No",
    ok: "Ok",
    cancel: "Cancel",
    confirm_cancel: "Confrim Cancel",
    upload_file: "Upload file",
    add: "Add",
    close: "Close",
    please_select: "Please select",
    please_select_payment_method_type: "Please select payment method",
    please_select_sale_channel_type: "Please select sale channel",
    please_select_shipping_provider_type: "Please select shipping provider",
	create: "Create",
	confirm: "Confirm",
	create_success: "Create success",
	delete_confirm: "Confirm delete",
	delete_confirm_text: "Please confirm delete ",
	delete_confirm_question: "Do you want to delete this information ? ",
	delete_success: "Delete successed",
	delete_fail: "Delete Failed",
	edit_success: "Editing successed",
	edit_fail: "Editing failed",
    update_success: "Updating successed",
    update_fail: "Updating failed",

    // Inventory
    inventory_transfer: "Pickup from Main",
    inventory_transfer_to_line: "Pickup to Line",
    inventory_out: "Out",
    inventory_in: "In",
    phone: "Phone",

    // =================================================================
    // WMS Module
    // =================================================================
    wms: {
        name: "Inventory System",
        menu: {
            inventory: "Inventory",
            inventory_list: "Inventory List",
            inventory_list_detail: "Inventory List By Stock",
            inventory_history: "Inventory History",
            partner: "Partner",
            product: "Product",
            storage: "Storage",
            promotion: "Promotion"
        },

        created_at: "Date",
        staff: "Staff",
        bill_number: "Bill Number",
        bill_image: "Bill Image",

        inventory_main: "Main Inventory",
        inventory_src: "Source",
        inventory_dst: "Destination",
        inventoryin_list: "In",
        inventoryout_list: "Out",
        inventorytransfer_list: "Transfer",
        // Prodcut
        product_name: "Product Name",
        partner: "Partner",
        package_name: "Unit name",
        barcode: "Barcode",
        product_width: "Width",
        product_height: "Height",
        product_depth: "Depth",
        product_weight: "Weight",
        product_pn: "SKU",

        // Partner
        company_name: "Company Name",
        address: "Address",
        contact_name: "Contact",
        contact_tel: "Telephone",

        // Inventory
        inventory_in: "In",
        inventory_out: "Out",

        amount: "Amount",
        cost: "Cost",
        note: "Note",
        product: "Product",
        corporate: "Corporate",
        storage: "Storage",
        balance: "Balance",
        overall_amount: "Overall Amount",
        overall_cost: "Overall Cost",
        taxid: "TAX ID",
        tel: "Phone",
        email: "E-Mail",
        storage_name: "Storage Name",
        storage_desc: "Storage Description",
        x: "X",
        y: "Y",

        width: "Width (cm)",
        height: "Height (cm)",
        depth: "Depth (cm)",
        weight: "Weight (g)"
    },

    // =================================================================
    // Backoffice Module
    // =================================================================

    backoffice: "Backoffice",
    orders: "Orders",
    products: "Product",
    packings: "Packing",
    order_return: "Return",
    payments: "Payment",
    reports: "Report",
    customer_information: "Customer Information",
    customer: "Customer",
    platform_connect: "Platform Connect",
    product_information: "Product Information",
    seller_note: "Seller Note",
    order_form: "New Order",
    order_status: "Status",
    order_number: "Order Number",
    order_user: "Staff",
    order_detail: "Order Detail",
    order_form: "New Order",
    order_count: "Order Count",


    order_status_unpaid: "Unpaid",
    order_status_awaiting_shipment: "Awaiting Shipment",
    order_status_awaitingcollection: "Awaiting Collection",
    order_status_partiallyshipping: "Partially Shipping:",
    order_status_intransit: "Intransit",
    order_status_delivered: "Delivered",
    order_status_completed: "Completed",
    order_status_cancelled: "Cancelled",
    order_status_returned: "Returned",
    order_status_claimed: "Claimed",

    payment_slip: "Payment SLIP",
    payment_channel: "Payment Channel",
    payment_method: "Payment Channel",
    payment_check: "Payment Check",

    platform: "Platform",
    sale_channel: "Sale Channel",
    sale_channel_type: "Sale channel type",
    recipient_name: "Name",
    recipent_address: "Address",
    recipent_district: "District",
    recipent_city: "City",
    recipent_province: "Province",
    recipent_zipcode: "Zipcode",
    recipient_phone: "Phone",

    report_by_team: "Report By Team",
    report_by_sale_channel: "Report By SaleChannel",
    report_by_user: "Report By Staff",
    report_by_product: "Report By Prodcut",
    report_by_user_product: "Report By Staff And Product",

    time_from: "Start",
    time_to: "End",
    all: "All",
    type: "Type",
    bank: "Bank",
    bank_account: "Account Number",
    bank_branch: "Branch",
    detail: "Detail",
    product: "Product",
    price: "Procie",
    image: "Image",
    tag: "Tags",
    quantity: "Quantity",
    product_form: "Product Manage",
    product_code: "Product Code",
    product_category: "Product Category",
    team: "Team",
    department: "Department",
    fname: "Name",
    lname: "Lastname",
    nick_name: "Nickname",
    password_old: "Old password",
    password: "Password",
    password_confirm: "Confirm Password",
    password_not_match: "Password not match",
    packing_number: "Packing Number",
    packing_user: "Packing Staff",
    packing_date: "Packing Date",
    please_select_sale_channel: "Please select sale channel",
    please_select_payment_method: "Please select payment channel",
    payment_success: "Payment success",
    payment_fail: "Payment fail",
    shipping: "Shipping",
    shipping_provider: "Shipping Provider",
    barcode: "Barcode",
    scanbarcode: "Click to scan Barcode",
    product_pn: "Product Code",
    tracking_number: "Tracking Number",
    order_information: "Order Information",
    product_image: "Product Image",
    product_name: "Product Name",
    product_pickup: "Quantity",
    cancel_confirm: "Confirm cancel",
    cancel_confirm_question: "Cancel order ",
    cancel_order_success: "Cancel order success",
    please_select_cancel_reason: "Please select cancel reason",
    please_input_cancel_reason: "Plase input cancel reason",

    shipping_return: "Shipping Return",

    user_group: "User Group",

    // Report
    order_amount: "Order Amount",
    payment_amount: "Payment Amount",
    payment_amount_net: "Summary",
    product_amount: "Product Amount",
    discount: "Discount",
    payment_method_type: "Payment method type",
    sort_type: "Sort type",
    change_tracking_success: "Change tracking success",
    change_shipping_success: "Change shipping success",
	price_per_unit:"Price per unit",
};
